import { Button } from '@/components/forms';
import { InlineAlert } from '@/components/feedback';

export type RuleBoxProps = {
  /** Texto que a descrição deve conter. */
  pattern: string;
  onPatternChange?: (pattern: string) => void;
  /** Categoria que a regra aplica. */
  category: string;
  /** Lançamentos antigos afetados. */
  affectedCount: number;
  onCreate?: () => void;
  onOnlyThis?: () => void;
  /** Confirmação local depois de criar a regra ou alterar só este. */
  message?: string;
};

/** "Criar regra para lançamentos parecidos?" (`.rulebox`), no drawer do extrato. */
export function RuleBox({ pattern, onPatternChange, category, affectedCount, onCreate, onOnlyThis, message }: RuleBoxProps) {
  return (
    <div className="rulebox">
      <b>Criar regra para lançamentos parecidos?</b>
      <p>Quando a descrição contém</p>
      <div className="input"><input value={pattern} onChange={(e) => onPatternChange?.(e.target.value)} aria-label="Padrão da regra" /></div>
      <p>→ <b style={{ color: 'var(--gold-d)' }}>{category}</b> · afeta {affectedCount} {affectedCount === 1 ? 'lançamento antigo' : 'lançamentos antigos'} (os manuais não mudam)</p>
      <div className="acts">
        <Button onClick={onCreate}>Criar regra</Button>
        <Button variant="outline-navy" onClick={onOnlyThis}>Só este</Button>
      </div>
      {message && <InlineAlert>{message}</InlineAlert>}
    </div>
  );
}
